import { AnswerType, QuestionType } from "../components/Survey/types";
import { paths } from "../store/slices/Navigation/reducer";
import moment from 'moment';
import 'moment/locale/es';

export const phoneFormat = (phoneNumber: string, placeholder: string = ''): string => {
  if (!phoneNumber) return placeholder;
  let i = 0;
  const pattern = '### ### ####';
  const phone = phoneNumber?.replace(/\D/g,'');
  return pattern.replace(/#/g, _ => phone[i++]);
};

export const normalizeText = (text: string): string => {
  if (!text) return '';
  return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
};

export const formatNumber = (number: number | null): string => {
  if (!number) return '';
  return number.toLocaleString();
};

export const isSubpath = (path: string): boolean => {
  const regex = '^(?:/[^/]+){2,}$';
  return Boolean(path.match(regex)) ;
};

export const pathExists = (p: string): boolean => {
  return  Boolean(p.match(paths.map(path => path.path).join('|\\')));
};

const ADJECTIVES = [
  'gentil',
  'torpe',
  'culto',
  'limpio',
  'amable',
  'rudo',
  'astuto',
  'humilde',
  'modesto',
  'curioso',
  'lento',
  'veloz',
  'sabio',
  'sedoso',
  'elegante',
  'audaz',
  'alegre',
  'feliz',
  'contento',
  'triste',
];

const WORDS = [
  'caballo',
  'camello',
  'castor',
  'conejo',
  'elefante',
  'gato',
  'gorila',
  'tucan',
  'koala',
  'lagarto',
  'lobo',
  'mapache',
  'mono',
  'oso',
  'panda',
  'pato',
  'perro',
  'sapo',
  'tigre',
  'tortuga',
];

const getRandomElement = (array: string[]): string => {
  const randomIndex = Math.floor(Math.random() * array.length);
  return array[randomIndex];
};

const capitalizeFirstLetter = (word: string): string => {
  return word.charAt(0).toUpperCase() + word.slice(1);
};

export const generatePassword = (): string => {
  const adjective = getRandomElement(ADJECTIVES);
  const capitalizedAdjective = capitalizeFirstLetter(adjective);
  const word = getRandomElement(WORDS);
  const randomNum1 = Math.floor(Math.random() * 10);
  const randomNum2 = Math.floor(Math.random() * 10);
  const password = `${word}${capitalizedAdjective}${randomNum1}${randomNum2}`;
  return password;
};

export const getQuestionTypeLabel = (questionType: QuestionType): string => {
  switch (questionType) {
    case QuestionType.TEXT:
      return 'Texto';
    case QuestionType.BOOLEAN:
      return 'Sí / No';
    case QuestionType.MULTIPLE:
      return 'Opción múltiple';
    case QuestionType.RANGE_SCALE:
      return 'Escala';
    default:
      return '';
  }
};

export const getAnswerTypeLabel = (answerType: AnswerType): string => {
  switch (answerType) {
    case AnswerType.SINGLE:
      return 'Única';
    case AnswerType.MULTIPLE:
      return 'Múltiple';
    default:
      return '';
  }
};

export const formatDate = (date?: string): string => {
  if (!date) return 'Fecha inválida';
  return moment(date).locale('es').format('LL');
};

export const formatDatetime = (date?: string): string => {
  if (!date) return 'Fecha inválida';
  return moment(date).locale('es').format('L - h:mm A');
};

export const maxLengthHandler = (input: string, maxLength: number): string => {
  return input.slice(0, maxLength);
};
